/* eslint-disable consistent-return */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  getUserData,
  getUserDataOrganization,
} from '../../../services/ClienteDados/getClientData'
import { apiService } from '../../../services/_config_/apiservice'

export const useTopUserData = () => {
  const [isOrganization, setIsOrganization] = useState(false)
  const [isShowConfig, setIsShowConfig] = useState(false)
  const [adm, setAdm] = useState(localStorage.getItem('adm'))
  const [userData, setUserData] = useState<GetSendIvitationType>()
  const [userDataOrganization, setUserDataOrganization] =
    useState<GetUsersOrganizationType>()

  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const useOrg = XTENANTID != null ? XTENANTID.slice(1, -1) : ' '
  const fetchUserData = async () => {
    const result = await getUserData()
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUserData(result)
    }
  }

  const fetchUserDataOrganization = async () => {
    const result = await getUserDataOrganization(useOrg)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUserDataOrganization(result)
    }
  }

  const showConfig = () => setIsShowConfig(!isShowConfig)

  const handleFiltroCliente = (event: string) => {
    localStorage.setItem('adm', JSON.stringify(event))

    setAdm(event)
  }

  const handleGuardaXtenantId = () => {
    const xtenantIdLogado = localStorage.getItem('X-TENANT-ID')
    const useOrgLogado =
      xtenantIdLogado != null ? xtenantIdLogado.slice(1, -1) : ' '
    localStorage.setItem('xtenantId', JSON.stringify(useOrgLogado))
  }

  const handleValidaXtenantId = () => {
    const xtenantIdRetornoAdm = localStorage.getItem('xtenantId')
    const xtenantIdRetorno =
      xtenantIdRetornoAdm != null ? xtenantIdRetornoAdm.slice(1, -1) : ' '

    localStorage.setItem('X-TENANT-ID', JSON.stringify(xtenantIdRetorno))

    const teste = localStorage.getItem('X-TENANT-ID')
    if (teste) {
      const xtenantIdRetornoConverte = JSON.parse(teste)

      apiService.defaults.headers.common[
        'X-TENANT-ID'
      ] = `${xtenantIdRetornoConverte}`
      showConfig()
    }
  }

  useEffect(() => {
    const ADM = localStorage.getItem('adm')
    if (ADM) {
      setAdm(JSON.parse(ADM))
    }
  }, [])

  useEffect(() => {
    // Sem token (ex.: tela de login) nao ha sessao: nao buscar nada, senao
    // /central/usuario/me responde 401 e getUserData redireciona para '/',
    // gerando recarga infinita da tela de login.
    const token = localStorage.getItem('token')
    if (token === null) {
      return
    }
    // O papel global (papel) vem de /central/usuario/me, endpoint do banco
    // Master que independe de tenant. Buscar sempre que houver sessao, para
    // que o super-admin sem organizacao ativa ainda seja reconhecido como
    // ADMINISTRADOR e consiga acessar o ambiente administrativo (criar a
    // primeira organizacao).
    fetchUserData()
    // Dados do papel na organizacao dependem do tenant selecionado.
    if (XTENANTID !== null) {
      fetchUserDataOrganization()
    }
  }, [])

  return {
    userData,
    userDataOrganization,
    adm,
    setAdm,
    showConfig,
    isShowConfig,
    handleFiltroCliente,
    isOrganization,
    setIsOrganization,
    handleValidaXtenantId,
    handleGuardaXtenantId,
  }
}
